export interface FilterType<T = string | number | null> {
    id: T,
    key: string,
    label: string | JSX.Element,
}

export interface FiltersStateStrategy<T = string | number | null> {
    filters: FilterType<T>[],
    getActiveFilterId: () => T,
    setActiveFilterId: (id: T) => void,
    isFilterDisabled?: (id: T) => boolean,
}

export class FiltersState<T = string | number | null> {

    constructor(
        private readonly strategy: FiltersStateStrategy<T>,
        public readonly id: string = ''
    ) {
    }

    get filters(): FilterType<T>[] {
        return this.strategy.filters;
    }

    get activeFilterId(): T {
        return this.strategy.getActiveFilterId();
    }

    bindSetActiveFilterId = (id: T) => {
        return (): void => {
            this.strategy.setActiveFilterId(id);
        };
    }

    isFilterDisabled = (id: T): boolean => {
        if (this.strategy.isFilterDisabled !== undefined) {
            return this.strategy.isFilterDisabled(id);
        }
        return false;
    }

    isFilterActive = (id: T): boolean => {
        return this.activeFilterId === id;
    }

}
